import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';
import { TypeDestinationClient } from './types';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.TipoDestinazioneAdd],
  create: [SystemAuthorizations.TipoDestinazioneDelete],
  edit: [SystemAuthorizations.TipoDestinazioneQuery],
  delete: [SystemAuthorizations.TipoDestinazioneUpdate],
});

export const validationSchemaTypesDestinationFilterForm = yup.object({
  code: yup.number().nullable().notRequired(),
  description: yup.string().nullable().notRequired(),
  queueName: yup.string().nullable().notRequired(),
});

export const headCells: HeadCell<TypeDestinationClient, keyof TypeDestinationClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'queueName',
    label: 'Nome Coda',
  },
  {
    id: 'action',
    label: '',
  },
];
